import { render, staticRenderFns } from "./UpdateSchedulerTableOasis.vue?vue&type=template&id=35f3b773"
import script from "./UpdateSchedulerTableOasis.vue?vue&type=script&lang=js"
export * from "./UpdateSchedulerTableOasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports